var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-content"},[_c('h2',[_vm._v("Erasmus MC")]),_vm._v(" "),_c('a',{staticClass:"button",attrs:{"href":"https://www.erasmusmc.nl","target":"_blank"},on:{"click":_vm.trackLink}},[_vm._v("Ga naar de site!")])])}
var staticRenderFns = []

export { render, staticRenderFns }